// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import SnsViber from '../_raw/ui/icon_sns_viber.svg';
import withIconProps from '../withIconProps';

export default withIconProps(SnsViber);
